import { render, staticRenderFns } from "./HorariosItem.vue?vue&type=template&id=53f6cc60&scoped=true"
import script from "./HorariosItem.vue?vue&type=script&lang=js"
export * from "./HorariosItem.vue?vue&type=script&lang=js"
import style0 from "./HorariosItem.vue?vue&type=style&index=0&id=53f6cc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6cc60",
  null
  
)

export default component.exports